import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'fc-header',
    templateUrl: './header-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HeaderContainerComponent {}
